var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIsotipo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 549.99 456.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Recurso 3isotipo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.36,49.27c0,27,45.29,48.8,101.23,48.8h7.67c55.27-.38,99.84-22.07,99.84-48.8S223.44.82,168.1.5h-7.48C104.68.5,59.39,22.32,59.39,49.27",
    style: {
      fill: "#7ab2e1",
      stroke: "#7ab2e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.09,49.27c0,27,45.33,48.8,101.27,48.8H396c55.27-.38,99.91-22.07,99.91-48.8S451.16.82,395.83.5h-7.47C332.42.5,287.09,22.32,287.09,49.27",
    style: {
      fill: "#7ab2e1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.42,207.2c-29.91,0-54.12,50.26-54.12,112.36v26.06c.38,61.34,24.43,110.84,54.12,110.84s53.77-49.63,54.15-111.07V319.56c0-62.1-24.28-112.36-54.15-112.36",
    style: {
      fill: "#004b93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.43,207.2c-29.91,0-54.15,50.26-54.15,112.36v26.06c.38,61.34,24.46,110.84,54.15,110.84s53.77-49.63,54.12-111.07V319.56c0-62.1-24.25-112.36-54.12-112.36",
    style: {
      fill: "#004b93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,161.86c0,27,45.29,48.8,101.26,48.8h3.28c55.31-.35,99.92-22.09,99.92-48.8s-44.71-48.45-100-48.8h-3.18C45.28,113.06,0,134.93,0,161.86",
    style: {
      fill: "#004b93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.53,161.86c0,27,45.29,48.8,101.26,48.8h3.31c55.28-.35,99.89-22.09,99.89-48.8s-44.67-48.45-100.07-48.76h-3.13c-56,0-101.26,21.87-101.26,48.8",
    style: {
      fill: "#004b93"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsotipo);
export default __webpack_public_path__ + "static/media/isotipo.87ab101797927eaf3fca383bcb389652.svg";
export { ForwardRef as ReactComponent };